export enum UserRole {
  mechanic = 0,
  executor = 1,
  plugin = 2
}
